// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","navLinks":"Header_navLinks__s95Sk","bottomBorder":"Header_bottomBorder__D71Jg"};